(function () {
	const announcementSlider = () => {
		$(".announcement-bar__slide").each(function () {
			if ($(this).hasClass("slider_started")) {
				return "";
			}
			if ($(".announcement-bar")) {
				$(this).addClass("slider_started");
			}

			const announcementId = $(this).data("announcement-id");
			const autoplayEnabledRaw = $(this).data("autoplay");
			const autoplayDelayRaw = $(this).data("autoplay-delay");
			const speedRaw = $(this).data("speed");
			const autoplayEnabled = String(autoplayEnabledRaw) === "true" || autoplayEnabledRaw === true;
			const autoplayDelay = Number(autoplayDelayRaw) || 3000;
			const speed = Number(speedRaw) || 500;
			const announcementSwiper = new Swiper(
				`.announcement-js-${announcementId}`,
				{
					loop: false,
					speed: speed,
					autoplay: autoplayEnabled
						? {
							delay: autoplayDelay,
							disableOnInteraction: false
						}
						: false,
					navigation: {
						nextEl: `#shopify-section-${announcementId} .announcement-btn-next`,
						prevEl: `#shopify-section-${announcementId} .announcement-btn-prev`,
					},
				}
			);
		});
	};

	announcementSlider();
	document.addEventListener("shopify:section:load", function () {
		announcementSlider();
	});
})();
